import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-references-report-help-modal',
  templateUrl: './references-report-help-modal.component.pug',
  styleUrls: ['./references-report-help-modal.component.scss'],
  standalone: false
})
export class ReferencesReportHelpModalComponent implements OnInit {

  constructor(
    private modalService: BsModalService,
    private permissionsService: PermissionsService,
  ) { }

  ngOnInit(): void { }

  closeModal(): void {
    this.modalService.hide()
  }
}
